import React, { useState, useEffect, useRef } from "react";
import $ from "jquery";
import "datatables.net";
import "datatables.net-dt/css/jquery.dataTables.css";
import { AES, enc } from "crypto-js";
import swal from "sweetalert";
import { BASE_URL } from "../CommonApi";
import "./BankAcc.css";
import BankAccNew from "./BankAccNew";
import BankDetails from "./BankDetails";
import * as XLSX from "xlsx";
import { FiSearch, FiEdit2, FiTrash2, FiDownload, FiPlus } from "react-icons/fi";
import { BsBank2 } from "react-icons/bs";

function BankAcc({ navigation }) {
  const [showCard, setShowCard] = useState(true);
  const [showUpdate, setShowUpdate] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const btnRef = useRef();

  const handleNavigation = (key) => {
    if (navigation.state.routes[navigation.state.index].key !== key) {
      navigation.navigate(key);
    }
  };

  const handleBankClick = () => {
    handleNavigation("BankAccNew");
  };

  const handleCancelNew = () => {
    setShowCard(true);
    setShowUpdate(false);
    setShowDetails(false);
    fetchDataAndInitializeDataTable();
  };

  const encryptedUniqueId = localStorage.getItem("uniqueId1");
  const decryptedUniqueId = AES.decrypt(
    encryptedUniqueId,
    "1234567812345678"
  ).toString(enc.Utf8);

  const [postData, setPostData] = useState({
    uniqueId: decryptedUniqueId,
  });

  const [bankData, setBankData] = useState([]);
  const [itemId, setItemID] = useState(true);
  const [bankId, setBankId] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchDataAndInitializeDataTable = () => {
    const jwtToken = localStorage.getItem("jwtToken");
    const apiUrl = BASE_URL + "/fetchBanks";

    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(postData),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("POST request failed");
        }
      })
      .then((responseData) => {
        setBankData(responseData.responseMessage);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchDataAndInitializeDataTable();
  }, []);

  const handleEdit = (id) => {
    setItemID(id);
    setShowCard(false);
    setShowUpdate(true);
  };

  const handleOpenDetails = (id) => {
    setBankId(id);
    fetchDataAndInitializeDataTable();
    setShowCard(false);
    setShowDetails(true);
    setShowUpdate(false);
  };

  const handleDelete = (id) => {
    const userConfirmed = window.confirm(
      "Are you sure? Once deleted, you will not be able to recover this bank data!"
    );
    const jwtToken = localStorage.getItem("jwtToken");

    if (userConfirmed) {
      fetch(BASE_URL + `/deleteBank/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            setBankData((prevBankData) =>
              prevBankData.filter((data) => data.id !== id)
            );

            swal({
              icon: "success",
              title: "Bank Data Deleted Successfully",
            });
            setLoading(true);
            fetchDataAndInitializeDataTable();
          } else {
            console.error("Failed to delete bank", id);
          }
        })
        .catch((error) => {
          console.error("Error deleting bank:", error);
        });
    }
  };

  const downloadBankInXl = () => {
    const worksheet = XLSX.utils.json_to_sheet(bankData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "BankAcc");
    XLSX.writeFile(workbook, "BankAcc.xlsx");
  };

  // Filter banks based on search term
  const filteredBanks = bankData.filter(bank =>
    bank.bankName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    bank.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    bank.accountType?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    bank.currency?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return (
      <div className="bank-loading-container">
        <div className="bank-spinner"></div>
      </div>
    );
  }

  return (
    <div className="bank-accounts-wrapper">
      {!showUpdate && !showDetails && (
        <>
          {/* Page Header */}
          <div className="bank-page-header">
            <div className="header-left">
              <h1 className="page-title">Bank Accounts</h1>
              <p className="page-subtitle">Manage your bank accounts</p>
            </div>
          </div>

          {/* Toolbar */}
          <div className="bank-toolbar">
            <div className="toolbar-left">
              <div className="search-container">
                <FiSearch className="search-icon" />
                <input
                  type="text"
                  className="search-input"
                  placeholder="Search banks..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
            <div className="toolbar-right">
              <button className="btn-new-bank" onClick={handleBankClick}>
                <FiPlus size={18} />
                <span>New Bank</span>
              </button>
              <div className="dropdown-container">
                <button
                  className="btn-more"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                  ref={btnRef}
                >
                  <i className="fa fa-ellipsis-v"></i>
                </button>
                {dropdownOpen && (
                  <div className="dropdown-menu-custom">
                    <button className="dropdown-item" onClick={downloadBankInXl}>
                      <FiDownload size={16} />
                      <span>Export Banks</span>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Table Card */}
          <div className="bank-table-card">

            {/* Table or Empty State */}
            {filteredBanks && filteredBanks.length > 0 ? (
              <div className="table-wrapper">
                <table className="bank-table">
                  <thead>
                    <tr>
                      <th>Bank Name</th>
                      <th>Account Type</th>
                      <th>Account Name</th>
                      <th>Currency</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredBanks.map((data) => (
                      <tr key={data.id}>
                        <td>
                          <div className="bank-name-cell">
                            <BsBank2 className="bank-icon" />
                            <a
                              href="#"
                              className="bank-link"
                              onClick={(e) => {
                                e.preventDefault();
                                handleOpenDetails(data.id);
                              }}
                            >
                              {data.bankName}
                              {data.primaryAccount === "YES" && (
                                <span className="primary-badge">Primary</span>
                              )}
                            </a>
                          </div>
                        </td>
                        <td>
                          <span className="account-type-badge">
                            {data.accountType}
                          </span>
                        </td>
                        <td className="account-name">{data.name}</td>
                        <td>
                          <span className="currency-pill">{data.currency}</span>
                        </td>
                        <td>
                          <div className="action-buttons">
                            <button
                              className="btn-action btn-edit"
                              onClick={() => handleEdit(data.id)}
                            >
                              <FiEdit2 size={16} />
                            </button>
                            <button
                              className="btn-action btn-delete"
                              onClick={() => handleDelete(data.id)}
                            >
                              <FiTrash2 size={16} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="empty-state">
                <BsBank2 className="empty-icon" />
                <h3 className="empty-title">No bank accounts found</h3>
                <p className="empty-text">
                  {searchTerm
                    ? "Try adjusting your search criteria"
                    : "Get started by adding your first bank account"}
                </p>
                {!searchTerm && (
                  <button className="btn-empty-action" onClick={handleBankClick}>
                    <FiPlus size={18} />
                    <span>Add Bank Account</span>
                  </button>
                )}
              </div>
            )}
          </div>
        </>
      )}

      {showUpdate && <BankAccNew navigation={navigation} id={itemId} handleCancle={handleCancelNew} />}
      {showDetails && <BankDetails navigation={navigation} id={bankId} handleCancle={handleCancelNew} />}
    </div>
  );
}

export default BankAcc;
